import UserSettingsQuery from '@/api/account/user_settings/query.js';
import UserSettingsUpdate from '@/api/account/user_settings/update.js';

export const userSettings = {
  strict: process.env.NODE_ENV === 'local',
  namespaced: true,
  state: {
    userDialogSettings: {}
  },
  getters: {
    getUserDialogSettings: state => state.userDialogSettings
  },
  mutations: {
    setUserDialogSettings(state, userDialogSettings) {
      state.userDialogSettings = userDialogSettings;
    }
  },
  actions: {
    setUserDialogSettings({ commit }) {
      UserSettingsQuery.getUserDialogSettings().then(res => {
        commit('setUserDialogSettings', res.data.data);
      });
    },
    async updateUserDialogSettings({ state, dispatch }, payload) {
      // payload = { key : value }
      const userDialogSettings = { ...state.userDialogSettings, ...payload };
      await UserSettingsUpdate.updateUserDialogSettings(userDialogSettings).then(_ => {
        dispatch('setUserDialogSettings');
      });
    }
  }
};



// WEBPACK FOOTER //
// ./src/store/modules/user_settings.js